'use strict';
import './lib/register-module';

import {initCommonModules} from './commons';

initCommonModules();
